import {
  Directive,
  ElementRef,
  Input,
  AfterViewInit,
  OnDestroy
} from '@angular/core';

@Directive({
  selector: '[appTooltip]' // usage: <div appTooltip>
})
export class TooltipDirective implements AfterViewInit, OnDestroy {
  @Input('appTooltip') tooltipText: string = '';
  @Input() placement: string = 'top';

  private tooltipInstance: any;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const bootstrap = (window as any).bootstrap;
    if (bootstrap?.Tooltip) {
      this.tooltipInstance = new bootstrap.Tooltip(this.el.nativeElement, {
        title: this.tooltipText,
        placement: this.placement,
        trigger: 'hover'
      });

      
      this.el.nativeElement.addEventListener('click', this.removeAllTooltips);
    }
  }

  ngOnDestroy(): void {
    if (this.tooltipInstance) {
      this.tooltipInstance.dispose();
    }
    this.el.nativeElement.removeEventListener('click', this.removeAllTooltips);
  }

  removeAllTooltips() {
    document.querySelectorAll('.tooltip')?.forEach(tt => tt.remove());
  }
}